import { render, staticRenderFns } from "./SettingsWindow.vue?vue&type=template&id=1d592fa6&"
import script from "./SettingsWindow.vue?vue&type=script&lang=js&"
export * from "./SettingsWindow.vue?vue&type=script&lang=js&"
import style0 from "./SettingsWindow.vue?vue&type=style&index=0&id=1d592fa6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports